// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MessageStopFetchResponding_bubble__mvIa9 {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    border: 1px solid #FDE0D0;
    background-color: #fde0d0;
    border-radius: 6px;
    transition: all 2s ease-in-out;
    transform-origin: center bottom;
    cursor: default;
}

.MessageStopFetchResponding_appear__boqsz {
    animation: MessageStopFetchResponding_bubbleIn__iknjA 0.5s forwards;
}

.MessageStopFetchResponding_disappear__zL-5N {
    animation: MessageStopFetchResponding_bubbleOut__T1t2p 2s forwards;
}

.MessageStopFetchResponding_img__j4JBK {
    width: 18px;
    height: 18px;
}

.MessageStopFetchResponding_text__OgDmv {
    font-size: 14px;
    color: #E31A1A;
}

@keyframes MessageStopFetchResponding_bubbleIn__iknjA {
    0% {
        transform: scale(0);
        opacity: 0;
    }
    50% {
        transform: scale(1.2);
        opacity: 1;
    }
    100% {
        transform: scale(1);
    }
}

@keyframes MessageStopFetchResponding_bubbleOut__T1t2p {
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/home/components/MessageStopFetchResponding/index.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,8BAA8B;IAC9B,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,mEAAiC;AACrC;;AAEA;IACI,kEAAgC;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI;QACI,mBAAmB;QACnB,UAAU;IACd;IACA;QACI,qBAAqB;QACrB,UAAU;IACd;IACA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ","sourcesContent":[".bubble {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: space-evenly;\n    align-items: center;\n    border: 1px solid #FDE0D0;\n    background-color: #fde0d0;\n    border-radius: 6px;\n    transition: all 2s ease-in-out;\n    transform-origin: center bottom;\n    cursor: default;\n}\n\n.appear {\n    animation: bubbleIn 0.5s forwards;\n}\n\n.disappear {\n    animation: bubbleOut 2s forwards;\n}\n\n.img {\n    width: 18px;\n    height: 18px;\n}\n\n.text {\n    font-size: 14px;\n    color: #E31A1A;\n}\n\n@keyframes bubbleIn {\n    0% {\n        transform: scale(0);\n        opacity: 0;\n    }\n    50% {\n        transform: scale(1.2);\n        opacity: 1;\n    }\n    100% {\n        transform: scale(1);\n    }\n}\n\n@keyframes bubbleOut {\n    0% {\n        opacity: 1;\n    }\n    100% {\n        opacity: 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bubble": `MessageStopFetchResponding_bubble__mvIa9`,
	"appear": `MessageStopFetchResponding_appear__boqsz`,
	"bubbleIn": `MessageStopFetchResponding_bubbleIn__iknjA`,
	"disappear": `MessageStopFetchResponding_disappear__zL-5N`,
	"bubbleOut": `MessageStopFetchResponding_bubbleOut__T1t2p`,
	"img": `MessageStopFetchResponding_img__j4JBK`,
	"text": `MessageStopFetchResponding_text__OgDmv`
};
export default ___CSS_LOADER_EXPORT___;
